var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-nu",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h496.06v496.06H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "scale(1.0321)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fff",
    d: "M.013 0h499.55v248.1H.013z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.013 0l-.02 18.621 119.21 61.253 44.86 1.3L.012 0z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.054 0l144.53 75.491V.001H51.064z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M214.86 0v96.372H.02v55.07h214.84v96.372h66.106v-96.372h214.84v-55.07h-214.84V0H214.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.24 0v71.132L441.63.552 300.24 0z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.71 78.887l39.76-.32L498.95.551l-40.99.668-153.25 77.668z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.013 167.5v52.775l99.16-52.22-99.16-.56z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.85 169.68l-41.336-.321 155.82 77.58-1.025-17.749-113.46-59.51zM38.73 248.25l146.11-76.71-38.38.26L.01 248.14",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.9 21.795l-118 58.515 116.43.436v87.194h-99.159l98.242 53.23 1.442 27.08-52.474-.627-143.62-70.505v71.132h-104.67v-71.132l-134.72 70.94-60.844.192v247.81h991.59V.43L498.947 0M.537 27.971L.014 79.438l104.39 1.308L.544 27.971z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    fill: "#ffd900"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.06 0h496.06v496.06H496.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 248.03h523.49v248.03H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.9 125.29c0 23.619-19.148 42.767-42.768 42.767-23.619 0-42.767-19.147-42.767-42.767s19.147-42.767 42.767-42.767c23.62 0 42.767 19.147 42.767 42.767z",
    fill: "#000067"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff40d",
    d: "M226.833 154.052l8.27-24.576-21.6-15.182 26.686.025 8.225-24.59 8.224 24.59 26.686-.018-21.603 15.175 8.266 24.58-21.577-15.211zm155.285-17.104l4.098-11.506-10.704-7.107 13.225.011 4.076-11.512 4.076 11.512 13.226-.008-10.707 7.104 4.097 11.508-10.694-7.122zm-144.68 85.54l4.098-11.506-10.704-7.107 13.225.011 4.076-11.512 4.076 11.512 13.226-.008-10.707 7.104 4.097 11.508-10.694-7.122zm0-167.05l4.098-11.506-10.704-7.107 13.225.011 4.076-11.512 4.076 11.512 13.226-.008-10.707 7.104 4.097 11.508-10.694-7.122zM92.31 136.948l4.099-11.506-10.705-7.107 13.226.011 4.076-11.512 4.076 11.512 13.225-.008-10.706 7.104 4.096 11.508-10.693-7.122z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNu);
export default __webpack_public_path__ + "static/media/nu.a60461b01b2c78609042d8a7e778a5c6.svg";
export { ForwardRef as ReactComponent };